// โครงการพิเศษที่ทีมบัญชีใช้เป็นหมวดบันทึก Expense สำหรับยืม/คืนเงิน (ไม่ใช่โครงการก่อสร้างจริง)
export const BORROW_PROJECT = {
  name: 'ยืมเงินเพื่อการลงทุน',
  number: 'JSID_00003',
};

export const REPAY_PROJECT = {
  name: 'คืนเงินค่างาน-หนี้-การลงทุนและอื่นๆ',
  number: 'JSID_00002',
};
